<template>
  <div>
    <p class="page-title">整体报告</p>
    <panel :url="url"
           :bg-url="bgUrl"
           :content="content"
           bg-align="left-bottom"
           section="信息传递"></panel>
  </div>
</template>

<script>
import panel from './panel-2'
export default {
  components: {
    panel,
  },
  data () {
    return {
      url: require('@/assets/access_images/access-google.png'),
      bgUrl: require('@/assets/access_images/access-google_bg.png'),
      content: [
        '如果，Google给你带来的是科技',
        '那么，我们的Google Ads投放给你带来的是战略'
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
.page-title {
  padding: 20px;
  font-weight: 600;
  font-size: 15px;
}
</style>